import React from 'react';
import { Dialog } from 'primereact/dialog';
import type { DialogProps } from 'primereact/dialog';

import styles from './css/PFDialog.module.css';

interface PFDialogContainerProps extends DialogProps {
  children: React.ReactNode;
}

const PFDialogContainer: React.FC<PFDialogContainerProps> = ({
  children,
  className,
  ...props
}) => (
  <Dialog className={`${styles.customDialog} ${className ?? ''}`} {...props}>
    {children}
  </Dialog>
);

export default PFDialogContainer;
